export default {
  "World Heritage Organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["World Heritage<br>Organization"])},
  "World Heritage Visitor Center": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["World Heritage<br>Visitor Center"])},
  "World Heritage Experience": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["World Heritage<br>Experience"])},
  "World Heritage virtual": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["World Heritage<br>virtual"])}
}